import React, { forwardRef } from 'react'

import { Box, BoxProps } from '../Box'

export const FormControlContext = React.createContext(null)

////////////////////////////////////

export interface FormControlProps extends BoxProps {
  isRequired?: boolean
  isDisabled?: boolean
  isInvalid?: boolean
  isReadOnly?: boolean
  isFullWidth?: boolean
}

export const FormControl = forwardRef(
  (
    {
      isInvalid,
      isRequired,
      isDisabled,
      isReadOnly,
      isFullWidth = true,
      ...restProps
    }: FormControlProps,
    ref,
  ) => {
    const context = {
      isRequired,
      isDisabled,
      isInvalid,
      isReadOnly,
    }

    return (
      <FormControlContext.Provider value={context}>
        <Box role="group" ref={ref} width={isFullWidth ? '100%' : null} {...restProps} />
      </FormControlContext.Provider>
    )
  },
)

FormControl.displayName = 'FormControl'

export default FormControl
